//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminUserController_unblockUser,
  Response$AdminUserController_unblockUser$Status$200,
  ResponseContentType$AdminUserController_unblockUser,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminUserController_unblockUser = () =>
  useApiClientMutation<
    Params$AdminUserController_unblockUser,
    Response$AdminUserController_unblockUser$Status$200[ResponseContentType$AdminUserController_unblockUser]
  >({ method: 'AdminUserController_unblockUser' });
